import { BANNER_DATA, FEATURES, REASONS } from '../../utils/const/values';
import styles from './style.module.scss';
import DetailBanner from '../../components/commonComponents/detailBanner';
import Features from '../../components/commonComponents/featureCard';
import MobileReasons from '../../components/commonComponents/reasonCard';
import router from 'next/router';
import { src } from '../../utils/common';
import FadeIn from '../../components/commonComponents/fadeIn';
import { useUserAgentInfo } from '../../context/user-agent';
import { WebPNativeImage } from '../../components/WebPImage';

/**
 *
 * @description 客户价值
 */

const Reasons = ({ data, title }) => {
  return (
    <div className={styles['reason-wrapper']}>
      <div className={styles['title']}>{title}</div>
      <div className={styles['container']}>
        {data.map((item, index) => {
          const reverse = index % 2 === 1;
          return (
            <FadeIn key={index}>
              <div
                className={`${styles['item']} ${
                  reverse ? styles['reverse'] : ''
                }`}
              >
                <WebPNativeImage src={src(item.pcPicUrl)} />
                <div className={styles['card']}>
                  <div className={styles['card-title']}>{item.title}</div>
                  <div className={styles['card-content']}>{item.content}</div>
                </div>
              </div>
            </FadeIn>
          );
        })}
      </div>
    </div>
  );
};

const Values = () => {
  const { isMobile } = useUserAgentInfo();

  return (
    <div className={styles.wrapper}>
      <DetailBanner
        bannerData={BANNER_DATA}
        onTry={() => router.push('/form/consult/business-values')}
        mode="value"
        textMode
      />
      <Features
        advantages={FEATURES}
        title="在更短的时间内提供卓越的音视频体验和创新玩法"
        align="left"
        expand
      />
      {isMobile ? (
        <MobileReasons reasons={REASONS} />
      ) : (
        <Reasons data={REASONS} title="为什么选择StreamLake" />
      )}
    </div>
  );
};

export default Values;
